import styled from 'styled-components'
import Colors from '../../theme/theme.color'

export const InputErrorMessageContainer = styled.p`
  width: 100%;
  color: ${Colors.error};
  font-size: 0.75rem;
  margin-top: 5px;
`
